var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 .833C4.946.833.833 4.946.833 10c0 5.054 4.113 9.167 9.167 9.167 5.054 0 9.167-4.113 9.167-9.167 0-5.054-4.113-9.167-9.167-9.167zM10 20C4.486 20 0 15.514 0 10S4.486 0 10 0s10 4.486 10 10-4.486 10-10 10zm0-11.667c.46 0 .833.42.833.938v5.625c0 .518-.372.937-.833.937-.46 0-.833-.419-.833-.937V9.27c0-.518.372-.938.833-.938zm0-4.166c-.692 0-1.253.56-1.253 1.25a1.252 1.252 0 002.505 0c0-.69-.56-1.25-1.252-1.25z",
    fill: "#02BD9C"
  })));
}
SvgInfo.displayName = 'Info';
export default SvgInfo;